import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';
import {getUSERID, getTPAID} from  '../global_helpers/sessionReturn.js';
// import router from '../../router';


const state = {
    agreementContext: {
        agreement: null
    }
};

const getters = {
    getAgreement: (state) => state.agreementContext
};

const actions = {
    async getAgreement({commit, dispatch}, proposal_id){
        let authHeader = getAuthHeader();
        
        axios.get('/agreement/?proposal_id='+proposal_id, authHeader)
        
        .then((res) => {
            commit('setAgreement', res.data);
        })
        
        .catch(dispatch('raiseMessage', 'Uh oh, there was an error returning the agreement!', {root: true}));
    },
    
    
    async createAgreement({commit, dispatch}, obj){
        let authHeader = getAuthHeader();
        let userID = getUSERID();
        
        obj.agreement['signer_user_id'] = userID;
        
        let entity = {
            id: getTPAID(),
            type: 'tpa'
        }
        
        axios.post('/agreement/?proposal_id='+obj.agreement.proposal_id, obj, authHeader)
        
        .then((res) => {
            commit('setAgreement', res.data);
            dispatch('getProposalList', entity, {root: true})
        })
        
        .catch(err => {
            console.log(err)
            dispatch('raiseMessage', 'Uh oh, there was an error creating the agreement!', {root: true});
        });
    },
    
    
    async updateAgreement({commit, dispatch}, obj){
        let authHeader = getAuthHeader();
        
        axios.post('/agreement/', obj, authHeader)
        
        .then((res) => {
            commit('setAgreement', res.data.agreement);
        })
        
        .catch(dispatch('raiseMessage', 'Uh oh, there was an error when updating the agreement!', {root: true}));
    },
    
    async deleteAgreement({dispatch}, agreement_id){
        let authHeader = getAuthHeader();
        let entity = {
            id: getTPAID(),
            type: 'tpa'
        }
        
        axios.delete('/agreement/?agreement_id='+agreement_id, authHeader)
        
        .then((res) => { 
            dispatch('raiseMessage', 'Agreement successfully deleted', {root: true})
            dispatch('getProposalList', entity, {root: true})
            console.log(res)
        })
        
        .catch(err => {
            console.log(err)
            dispatch('raiseMessage', 'Uh oh, there was an error deleting the agreement!', {root: true});
        });
    },
    
    async downloadAgreementPDF(state, item){
        console.log('ITEM IN HELPER')
        console.log(item)
        let agreement_id = item.agreement_id;
        
        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        let auth = {
            Authorization: authToken
        };
        axios({
            method: 'get',
            url: "/agreement/pdf/?agreement_id="+agreement_id,
            responseType: 'blob',
            headers: auth
        })
        .then((res) => {
            console.log('hit res')
            var url = window.URL.createObjectURL(res.data);
              var a = document.createElement('a');
              a.href = url;
              a.download = item.agreement_file_name+".pdf";
              document.body.appendChild(a);
              a.click();
              a.remove();          
        }).catch((res) => {
            console.error("Could not download the PDF report from the backend.", res);
        });
    },
    
    async downloadAgreementDOCX(state, item){
        let agreement_id = item.agreement_id;
        
        let token = sessionStorage.getItem('token');
        let authToken = "Token "+token;
        let auth = {
            Authorization: authToken
        };
        axios({
            method: 'get',
            url: "/agreement/docx/?agreement_id="+agreement_id,
            responseType: 'blob',
            headers: auth
        })
        .then((res) => {
            var url = window.URL.createObjectURL(res.data);
              var a = document.createElement('a');
              a.href = url;
              a.download = item.agreement_file_name+".docx";
              document.body.appendChild(a);
              a.click();
              a.remove();          
        }).catch((res) => {
            console.error("Could not download the docx report from the backend.", res);
        });
    },
};

const mutations = {
    setAgreement(state, data) {
        state.agreementContext.agreement = data.agreement;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};